import { useRowMetaContext } from '../../../context/RowMetaContext';
import { RowHeader } from './components/RowHeader';
import { Dropdown, useTheme } from '@fluentui/react';
import { PseudoRow, isApprovalRow, useApprovalStore } from '../../../../../../../_grid/grid3';
import { useMemo } from 'react';
import { useGridLayoutContext } from '../../../context/LayoutProvider';
import shallow from 'zustand/shallow';
import { ApprovalState } from '../../../../../../../api/generated/data-contracts';
import { getApprovalStateBackground } from '../../../../../../../_helpers/getApprovalStateBackground';
import { useConfigValues } from '../../../../../../../hooks/queries/useConfigValues';

export const GroupingRow = ({ row }: { row: PseudoRow }) => {
    const { subrowFamily } = useRowMetaContext();
    const approvals = useApprovalStore(store => store.approvals, shallow);
    const approvalRows = useMemo(() => subrowFamily.filter(isApprovalRow), [subrowFamily]);
    const theme = useTheme();
    const { gridRowStyles } = useGridLayoutContext();
    const { data } = useConfigValues(); // useTimeUIConfig();
    const config = data?.configuration;

    const overAllApprovalState = useMemo((): ApprovalState => {
        const { approvedCount, pendingCount, rejectedCount } = approvalRows.reduce(
            ({ rejectedCount, approvedCount, pendingCount }, row) => {
                const { approvalState } = approvals[row.id];
                return {
                    rejectedCount: rejectedCount + Number(approvalState === 'Rejected'),
                    approvedCount: approvedCount + Number(approvalState === 'Approved'),
                    pendingCount: pendingCount + Number(approvalState === 'Pending'),
                };
            },
            { rejectedCount: 0, approvedCount: 0, pendingCount: 0 },
        );
        if (rejectedCount) {
            return 'Rejected';
        }
        if (pendingCount) {
            return 'Pending';
        }
        if (approvedCount === approvalRows.length) {
            return 'Approved';
        }
        throw new Error('Unable to resolve overall ApprovalState');
    }, [approvalRows, approvals]);

    return (
        <div style={gridRowStyles}>
            <RowHeader />
            <HoursColumn />
            <div />
            {/* Billable (hrs) column */}
            <div /> {/* date column */}
            {config?.approval?.projectManagerApproval?.useRates && <div>{/* rate column */}</div>}
            {config?.approval?.projectManagerApproval?.useRates && <div>{/* activity column */}</div>}
            {row.type === 'project' && (
                <div>
                    <Dropdown
                        options={[{ key: 1, text: overAllApprovalState }]}
                        disabled
                        selectedKey={1}
                        styles={{ title: { backgroundColor: getApprovalStateBackground(overAllApprovalState, theme), color: 'white' } }}
                        onRenderCaretDown={() => null}
                    />
                </div>
            )}
            <div>{/* comment column */}</div>
        </div>
    );
};

const HoursColumn = () => {
    const { row } = useRowMetaContext();
    const hours = useMemo(() => row.timeEntry.hours.toNumber(), [row.timeEntry.hours]);
    return <div>{hours}</div>;
};
